import { memo, useState } from "react";

import MoreVertIcon from "@material-ui/icons/MoreVert";
import { Popover } from "antd";
import styled from "styled-components/macro";

import { ToolbarButton } from "components/base";
import {
  components,
  visibleToolbarComponents
} from "components/multiphase-chart/components/toolbar/Toolbar";
import { useChartSettings } from "components/multiphase-chart/context";

const OverflowToggle = () => {
  const [overflowVisible, setOverflowVisible] = useState(false);

  const [chartSettings] = useChartSettings();
  const overflowIndex = chartSettings.overflowIndex;
  // Same two filters in the same order as the strip, which is what
  // `overflowIndex` counts against - one list short and the slice is off by one.
  const readOnlyFiltered = chartSettings?.isReadOnly
    ? components.filter((c) => c.key !== "FullscreenToggle")
    : components;
  const overflowComponents = visibleToolbarComponents(
    readOnlyFiltered,
    chartSettings?.hiddenToolbarKeys
  );
  const isOverflowing = overflowIndex < overflowComponents.length - 1;
  const hiddenComponents = overflowComponents
    .slice(overflowIndex)
    .filter((c) => c.key !== "globalSettingsDivider");

  // If only one item is in the overflow menu, don't render overflow
  if (!isOverflowing || hiddenComponents.length < 2) return null;

  return (
    <Popover
      arrowPointAtCenter
      content={
        <OverflowWrapper>
          {hiddenComponents.map((component) => component)}
        </OverflowWrapper>
      }
      placement="bottomRight"
      trigger="click"
      open={overflowVisible}
      onOpenChange={(v) => setOverflowVisible(v)}>
      <ToolbarButton
        active={false}
        icon={<MoreVertIcon fontSize="large" />}
        overflowLabel=""
        tooltipText="More"
        onToggle={(v) => setOverflowVisible(v)}
        testId="multiproduct-overflow"
      />
    </Popover>
  );
};

export default memo(OverflowToggle);

const OverflowWrapper = styled.div`
  display: grid;
  gap: 4px;
  max-height: 300px;
  border-radius: var(--border-radius);
  padding: 8px 12px;
  margin: -12px -16px;
  overflow: hidden scroll;

  & > button {
    width: auto !important;
  }
`;
